import React from 'react';
import classNames from 'classnames';
import useSessionstorage from '@rooks/use-sessionstorage';

export const EventResponse = (props) => {
  const [submitedData] = useSessionstorage('submitedData');

  const { eventDetails, pageData, paymentLink, eventPaymentId } = submitedData || {};
  const { headline, response, bgColor, headlineColor } = pageData;
  const getLink = () => {
    window.open(`${paymentLink}?client_reference_id=${eventPaymentId}`, '__blank');
  };

  return (
    <div
      className={classNames({
        container: true,
        'w-full': true,
        'max-w-xs': true,
        'mx-auto': true,
        'bg-red-gradient': bgColor == 'red',
        'bg-green-gradient': bgColor == 'green',
        'bg-yellow-gradient': bgColor == 'yellow',
        'bg-white-gradient': bgColor == '#fff',
        'bg-black-gradient': bgColor == '#000',
      })}
    >
      <div className="successSubmit px-8 pt-6 pb-8 mb-4 mt-4">
        <br />
        <div style={{ fontSize: '16px', color: headlineColor || '#fff' }}>Event Name: {eventDetails?.name || ''}</div>
        <br />
        <h1 className="rejectionTitle text-center mt-4" style={{ color: headlineColor || '#fff' }}>
          {headline || 'Thank you!'}
        </h1>
        <p className="text-center text-white successText" style={{ fontSize: '14px' }}>
          {response || 'You information has been submitted for Event ' + eventDetails?.name + '. Use below Payment link to send payment and complete your registration.'}
        </p>
        <br />
        {paymentLink ? (
          <button className="buttonPagination paginationNext" onClick={getLink}>
            Click for payment.
          </button>
        ) : (
          <h2>No payment link available.</h2>
        )}
      </div>
    </div>
  );
};
